"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayRecipientStatus = void 0;
var MangopayRecipientStatus;
(function (MangopayRecipientStatus) {
    MangopayRecipientStatus["Pending"] = "PENDING";
    MangopayRecipientStatus["Active"] = "ACTIVE";
    MangopayRecipientStatus["Canceled"] = "CANCELED";
    MangopayRecipientStatus["Deactivated"] = "DEACTIVATED";
})(MangopayRecipientStatus || (exports.MangopayRecipientStatus = MangopayRecipientStatus = {}));
//# sourceMappingURL=MangopayRecipientStatus.js.map